"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = exports.device = exports.generateEnvironmentSDRN = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const utils_1 = require("./utils");
function generateEnvironmentSDRN(id) {
    return `sdrn:schibsted:environment:${id}`;
}
exports.generateEnvironmentSDRN = generateEnvironmentSDRN;
function formatDeviceInput(input) {
    if ((0, utils_1.isString)(input)) {
        return { id: input };
    }
    const { id, ...rest } = input || {};
    return { id, ...rest };
}
/**
 * Generate a device representation
 *
 * Several default values are used in a browser environment: acceptLanguage,
 * screenSize, userAgent, deviceType, viewportSize, localStorageEnabled. See
 * (device-browser.js)[device-browser.js] for implementation details.
 *
 * The browser implementation will also read the required values from the
 * `_pulse2cookie` and if needed sync with CIS. Note that *this is not
 * implemented for Node.js environments*. There are no default values in
 * Node.js.
 */
const device = (defaultValueHandler) => (input) => {
    const { device: deviceInput } = input || {};
    if (!deviceInput) {
        return undefined;
    }
    const formattedInput = (0, merge_1.default)({}, defaultValueHandler(), formatDeviceInput(deviceInput));
    const { id, additionalIds, ...props } = formattedInput;
    if (!id) {
        return undefined;
    }
    const baseDevice = {
        '@type': 'Device',
        environmentId: generateEnvironmentSDRN(id),
    };
    if (additionalIds) {
        baseDevice.additionalEnvironmentIds = additionalIds.map(generateEnvironmentSDRN);
    }
    return Object.assign(baseDevice, props);
};
exports.device = device;
const defaultValue = () => ({});
exports.defaultValue = defaultValue;
exports.default = (0, exports.device)(exports.defaultValue);
